export const SHOW_RESTAURANT_MODAL = 'show_restaurant_modal';
export const HIDE_RESTAURANT_MODAL = 'hide_restaurant_modal';
export const DELETE_BRANCH = 'delete_branch';
